export default (function () {
  var spacer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length === 1 ? args[0] * spacer : args.map(function (spacing) {
      return "".concat(spacer * spacing, "px");
    }).join(' ');
  };
});